"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./index.module.css");
var classnames_1 = require("classnames");
var identity_1 = require("@devsisters/ui-common/lib/identity");
var AppBar = function (_a) {
    var style = _a.style, className = _a.className, children = _a.children, title = _a.title;
    return (React.createElement("div", { className: classnames_1.default(styles.appBar, className) },
        React.createElement("div", { className: styles.logo },
            React.createElement(identity_1.DevsistersCi, null),
            title && React.createElement("p", { className: styles.title }, title)),
        React.createElement("div", { className: styles.gnb }, children)));
};
exports.default = AppBar;
